function ajaxCall(url,obj,type,onSuccess,onFailure, myGlobalsToken) {
	const searchParams = new URLSearchParams();
	searchParams.append('token',myGlobalsToken); 
	//url = 'https://api.npoint.io/624530841a7bfa10b571'
    if(type.localeCompare('POST')===0)
        fetch(url, {
  
          method: type,
//              headers: {
//                  'Content-Type': 'application/json',
//                  // 'Content-Type': 'application/x-www-form-urlencoded',
//              },
          body: searchParams,
  
        }).then(
          function(response){
            if (response.status !== 200) {
              console.log('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }
        ).then(function(data){
          onSuccess(data);
        }).catch(
          function(err)
          {
            console.log('Fetch Error :-S',err);
            onFailure(err);
          }
        );
    else
    {
      fetch(url, {
  
        method: type,
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
  
      }).then(
        function(response){
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }
      ).then(function(data){
        onSuccess(data);
      }).catch(
        function(err)
        {
          console.log('Fetch Error :-S',err);
          onFailure(err);
        }
      );
    }
  }
export default {
    ajaxCall: ajaxCall,
    ACHPaymentCompleted: false,
    getHistory: null,
    globalAccountId: "-1",
    initialHost: '',
    appender: '',
    token: '',
    globalCurrencySymbol: '',
    blockedStatuses: new Set(['Submitted for Bulk Payment','In-Progress','Scheduled']),
    errorMessage: '',
    selectedStateMethodPaymentContainer: null,
    checkPaymentContentSelected: null,
    languageContainer: null,
    messages: null,
    // injectProp: null,
    viewMoreHeight: 0,
    isDiscountEnabled: false,
    languageCode: 'en',
    topBuildResponse: null,
    jsonString: '',
    charactersToBlackList: /[!"%*=+:;<>?\[\\\]^`{|}~‚„ˆ“”]/,
    invalidRoutingNumberMessage : false,
    handleACHFormSubmit: null,
    poaCurrencies:null,
    PPRO_TNC_INFO: '',
    isDCFlow: false,
    isACHFlow: false,
    processPartialInvoices: false,
    modernUXinvData: {},
    modernUXdataToBePassed: {},
    flowName: '',
    triggermodernACHFlow: () => {},
    reDirectParamInURL: true,
    langCodeDLP: "en",
    linkTerminatedReason: "",
    cardFetchCallCompleted: true,
    isDirectDebitLoaded:false,
};
